/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const SeverityLabelEnum = {
  low: 'low',
  medium: 'medium',
  high: 'high',
} as const;
export type SeverityLabelEnum = (typeof SeverityLabelEnum)[keyof typeof SeverityLabelEnum];

export function instanceOfSeverityLabelEnum(value: any): boolean {
  for (const key in SeverityLabelEnum) {
    if (Object.prototype.hasOwnProperty.call(SeverityLabelEnum, key)) {
      if ((SeverityLabelEnum as Record<string, SeverityLabelEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function SeverityLabelEnumFromJSON(json: any): SeverityLabelEnum {
  return SeverityLabelEnumFromJSONTyped(json, false);
}

export function SeverityLabelEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeverityLabelEnum {
  return json as SeverityLabelEnum;
}

export function SeverityLabelEnumToJSON(value?: SeverityLabelEnum | null): any {
  return value as any;
}
